import { render, staticRenderFns } from "./PopoverRosterPatient.vue?vue&type=template&id=7f3f9068&scoped=true"
import script from "./PopoverRosterPatient.vue?vue&type=script&lang=js"
export * from "./PopoverRosterPatient.vue?vue&type=script&lang=js"
import style0 from "./PopoverRosterPatient.vue?vue&type=style&index=0&id=7f3f9068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f9068",
  null
  
)

export default component.exports